export default "skymp5-front/3d94b26bad1a62066baf7a505fa7a26c.mp3";